/**
 * @description - 链接配置
 * */

// 文档地址
export const DOCUMENT_URL = "https://slan-tech.feishu.cn/wiki/HOV3w3GJbimkN6kxGwrc6WbMnab";

// 更新日志
export const CHANGE_LOG_UEL = "https://portal.suwendata.com/change-log"